export default __webpack_public_path__ + "static/media/ddsu5168.9ec0bc3f.png";